import React from 'react';
import { motion } from 'framer-motion';
import { Clock, Frown, ShoppingBag, UtensilsCrossed } from 'lucide-react';
const painPoints = [{
  icon: <Clock className="h-8 w-8 text-terracotta" data-id="element-148" />,
  text: 'You have food in the house, but by the end of the day, you are too exhausted and too stressed to cook.'
}, {
  icon: <UtensilsCrossed className="h-8 w-8 text-terracotta" data-id="element-149" />,
  text: 'You want to serve delicious meals for your family, but the prep time needed is more than you have.'
}, {
  icon: <ShoppingBag className="h-8 w-8 text-terracotta" data-id="element-150" />,
  text: "You go out to eat (or order in) WAY more than you want because it's just easier than trying to cook."
}, {
  icon: <Frown className="h-8 w-8 text-terracotta" data-id="element-151" />,
  text: 'You hate being asked "what\'s for dinner?" because you never really know.'
}];
export const PainPoints = () => {
  return <section className="bg-white px-4 py-8 md:py-16 lg:px-8" data-id="element-152">
      <div className="mx-auto max-w-6xl" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-8 md:mb-16 text-center" data-id="element-154">
          <h2 className="font-serif text-4xl font-bold text-text-dark md:text-5xl" data-id="element-155">
            I've been there.
          </h2>
        </motion.div>

        {/* Grid of Cards */}
        <div className="mb-8 md:mb-16 grid gap-8 md:grid-cols-2" data-id="element-156">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-start space-y-4 rounded-2xl bg-gray-50 p-8 shadow-sm transition-shadow hover:shadow-md" data-id="element-157">
              <div className="rounded-full bg-white p-3 shadow-sm" data-id="element-158">
                {point.icon}
              </div>
              <p className="text-lg leading-relaxed text-text-dark" data-id="element-159">
                {point.text}
              </p>
            </motion.div>)}
        </div>

        {/* Testimonial Image */}
        <div className="mb-8 md:mb-16 mx-auto max-w-lg" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/bfqYBj6FvqTHf6rXFxpqQL/testimonio_2.jpg" alt="Testimonial from Laura" className="w-full rounded-xl shadow-md" data-id="element-161" />
        </div>

        {/* Narrative */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="mx-auto max-w-3xl space-y-6 text-center" data-id="element-162">
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-163">
            I was that mom. I wanted so badly to have dinner ready every night
            because isn't that what I'm supposed to do? But honestly, with our
            crazy lifestyle, it just wasn't possible!
          </p>
          <p className="text-xl leading-relaxed text-text-dark" data-id="element-164">
            Dinner time is CHAOS. Everyone is just getting home. Kids are grumpy
            and tired. You're praying you actually have everything you need. Who
            wants to try and chop up vegetables in the middle of that kind of
            nonsense?
          </p>
        </motion.div>

        {/* Intensely Tested Recipes Image */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-10 md:mt-16 mx-auto max-w-3xl" data-id="element-165">
          <img src="https://cdn.magicpatterns.com/uploads/wSSgaMhPZYgXfqQ1ttLaUW/foto.jpg" alt="Intensely Tested Recipes - Rosemary Pork Tenderloin, White Chicken Lasagna, Creamy Broccoli Cheddar Soup, General Tso Chicken, Cheesy Beef Pasta Bake, Hearty Beef Vegetable Soup and dozens more" className="w-full rounded-2xl shadow-lg" data-id="element-166" />
        </motion.div>
      </div>
    </section>;
};